import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { adminApi } from "../lib/api";
import { useSeo } from "../components/site/Layout";
import { euros } from "../data/site";

const Card = ({ label, value, to, testid, accent }) => (
  <Link to={to} data-testid={testid} className={`rounded-2xl p-6 border transition-shadow hover:shadow-lg ${accent ? "bg-navy text-white border-navy" : "bg-white border-slate-200"}`}>
    <p className={`text-sm font-semibold uppercase tracking-wider ${accent ? "text-mist/80" : "text-slate-600"}`}>{label}</p>
    <p className={`mt-3 font-display text-5xl ${accent ? "text-mist" : "text-navy"}`} data-testid={`${testid}-value`}>{value ?? "…"}</p>
  </Link>
);

export default function AdminDashboard() {
  useSeo("Tableau de bord admin");
  const [s, setS] = useState(null);
  useEffect(() => { adminApi.get("/stats").then((r) => setS(r.data)); }, []);
  return (
    <div data-testid="admin-dashboard">
      <h1 className="text-3xl sm:text-4xl">Tableau de bord</h1>
      <p className="mt-2 text-slate-600">Vue d'ensemble des demandes et des rendez-vous.</p>
      <div className="mt-8 grid sm:grid-cols-2 xl:grid-cols-4 gap-5">
        <Card accent label="Nouvelles demandes" value={s?.new_leads} to="/admin/demandes?status=nouveau" testid="stat-new-leads" />
        <Card label="RDV à venir" value={s?.upcoming_appointments} to="/admin/rdv" testid="stat-upcoming-appointments" />
        <Card label="Demandes au total" value={s?.total_leads} to="/admin/demandes" testid="stat-total-leads" />
        <Card label="Créneaux disponibles" value={s?.available_slots} to="/admin/creneaux" testid="stat-available-slots" />
        <Card accent label="Encaissé ce mois" value={s ? euros(s.paid_this_month_cents) : null} to="/admin/paiements?status=payé" testid="stat-paid-this-month" />
        <Card label="Paiements en attente" value={s?.pending_payments} to="/admin/paiements?status=en%20attente" testid="stat-pending-payments" />
      </div>
      {s && (
        <div className="mt-8 grid sm:grid-cols-3 gap-5">
          {Object.entries(s.leads_by_source).map(([k, v]) => (
            <div key={k} className="rounded-2xl bg-white border border-slate-200 p-5" data-testid={`stat-source-${k}`}>
              <p className="text-sm text-slate-600 capitalize">Source : {k}</p><p className="font-display text-3xl text-navy mt-1">{v}</p>
            </div>
          ))}
        </div>
      )}
      {s?.email_failures > 0 && (
        <p className="mt-8 rounded-xl bg-amber-50 border border-amber-200 p-4 text-amber-900" data-testid="stat-email-failures">
          {s.email_failures} demande(s) avec un envoi d'email en échec. Les demandes sont bien enregistrées ; consultez le détail pour le journal d'envoi.
        </p>
      )}
    </div>
  );
}
